import React, { useContext, useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import { CartContext } from "../context/cart-context";
import PopUp from "../PopUp/PopUp";

const CartItem = (props) => {
  const cart = useContext(CartContext);
  const { id, image, price, quantity, total, title, stock } = props;
  const [popUp, setShowPopUp] = useState(false);
  const errorMessage = `Only ${stock} in stock. Cannot increase further`;

  const showPopUp = () => {
    setShowPopUp(true);
    setTimeout(() => {
      setShowPopUp(false);
    }, 1500);
  };

  return (
    <React.Fragment>
      <div className="row my-2 text-capitalize text-center">
        <div className="col-10 col-lg-2 mx-auto">
          <img
            src={image}
            alt={title}
            className="img-fluid"
            style={{ width: "5rem", height: "5rem" }}
          />
        </div>
        <div className="col-10 col-lg-2 mx-auto">
          <span className="d-lg-none">Product: </span>
          {title}
        </div>
        <div className="col-10 col-lg-2 mx-auto">
          <span className="d-lg-none">Price: </span>${price}
        </div>
        <div className="col-10 col-lg-2 mx-auto my-2 my-lg-0">
          <div className="d-flex justify-content-center">
            <div>
              <span
                className="btn btn-outline-dark mx-1"
                onClick={() => cart.decrement(id)}
              >
                -
              </span>
              <span className="btn mx-1">{quantity}</span>
              <span
                className="btn btn-outline-dark mx-1"
                onClick={() => {
                  if (quantity === stock) {
                    showPopUp();
                    return;
                  }
                  cart.increment(id);
                }}
              >
                +
              </span>
            </div>
          </div>
        </div>
        <div className="col-10 col-lg-2 mx-auto text-danger">
          <DeleteIcon
            onClick={() => {
              cart.removeFromCart(id);
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="col-10 col-lg-2 mx-auto">{total}</div>
      </div>
      {popUp && <PopUp description={errorMessage} danger />}
    </React.Fragment>
  );
};

export default CartItem;
